import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import {
  emailTemplatesList,
  emailTemplatesListNext,
  openModal,
} from "../../actions";
import Table from "../../components/Table";
import EmailTemplateListItem from "../../components/EmailTemplateListItem";
import NonIdealState from "../../components/NonIdealState";
import Pin from "../../components/Pin";
import ListEmailTemplateToolbar from "./ListEmailTemplateToolbar";
import qs from "qs";

const identity = (data) => data;

export class ListEmailTemplatePage extends Component {
  constructor(props) {
    super(props);
    this.renderEmail = this.renderEmail.bind(this);
    this.fetchMore = this.fetchMore.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onClone = this.onClone.bind(this);
  }

  componentWillMount() {
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.props.emailTemplatesList(
      this.props.match.params.accountId,
      query,
      true
    );
  }

  onDelete(emailId) {
    this.props.openModal("delete-email-template", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onClone(emailId) {
    this.props.openModal("clone-email-template", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  fetchMore() {
    this.props.emailTemplatesListNext();
  }

  renderEmail(email) {
    return (
      <EmailTemplateListItem
        emailTemplate={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  render() {
    const { emailTemplates, isFetching } = this.props;
    const { accountId } = this.props.match.params;
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Email Templates`}</title>
        </Helmet>
        <Pin y={50}>
          <ListEmailTemplateToolbar
            accountId={accountId}
            searchTerm={query.name}
          />
        </Pin>
        {emailTemplates.length > 0 ? (
          <Table
            renderItem={this.renderEmail}
            items={emailTemplates}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : !isFetching ? (
          <NonIdealState title="No Templates Found" visual="warning" />
        ) : (
          <NonIdealState title="Loading" visual="refresh" spin />
        )}
      </div>
    );
  }
}

ListEmailTemplatePage.propTypes = {
  emailTemplatesList: PropTypes.func.isRequired,
  emailTemplatesListNext: PropTypes.func.isRequired,
  emails: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const emailTemplatesPagination = state.pagination.emailTemplates || {};
  const emailTemplates = (emailTemplatesPagination.ids || [])
    .map((id) => state.entities.emailTemplate[id])
    .filter(identity);
  const isFetching = emailTemplatesPagination.isFetching;

  return {
    emailTemplates,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailTemplatesList,
  emailTemplatesListNext,
  openModal,
})(ListEmailTemplatePage);
